import * as React from 'react';
import { Theme, WithStyles } from '@material-ui/core';
import { mockTheme, createWhattsappLink } from '../../utils/utils';
import withStyles from '@material-ui/core/styles/withStyles';
// import Stepper from '@material-ui/core/Stepper';
import Typography from '@material-ui/core/Typography';
// import Step from '@material-ui/core/Step';
// import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import RouteSelector, { RouteData } from '../routeSelector';
import { JSONSchema6 } from 'json-schema';
import EnhancedSchemaForm from '../schemaForm';
import { RowDefinition } from '../schemaform/layout-renderer';
import CheckCircle from '@material-ui/icons/CheckCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import googleMaps from '../../api/googleMaps';
import MoneyLabel from '../MoneyLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AddRaceDTO, RaceType } from '../../api/model';
import NumberFormat from 'react-number-format';
import { extractError } from '../../utils/errorHelper';
import { addDays, setMilliseconds } from 'date-fns';
import { ConfigData } from '../../config';
import { getApi } from '../../api/ApiProvider';



const styles = (theme: Theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },

    buttons: {
        textAlign: 'right'
    },

    success: {
        textAlign: 'center',
    },
    cardMedia: {
        width: 400,
        height: 400,
        minHeight: 400,
        margin: 'auto',
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

export interface RaceData {
    raceType: RaceType;
    observation?: string;
    withMoney: boolean;
    driver: number | null;
    amount?: number;
    dueDate?: string;
    user: { name: string, document: string, phone?: string, email?: string };
    origin: { street1: string, street2?: string, number?: number, observation?: string },
    destiny: { street1: string, street2?: string, number?: number, observation?: string },
}

export type RaceAbmState = 'edit' | 'adding' | 'added' | 'error';

interface RaceAddProps extends WithStyles<keyof typeof classesType> {
    state: RaceAbmState;
    config: ConfigData;
    error?: any;
    notification?: any;
    handleAdd(data: AddRaceDTO): void;
}

interface RaceAddState {
    steps: string[];
    activeStep: number;
    data: RaceData;
    routeData?: RouteData;
    schema: JSONSchema6 | null;
}

const addRaceSchema: JSONSchema6 = {
    definitions: {
        address: {
            type: 'object',
            required: ['street1'],
            properties: {
                street1: { type: 'string', title: 'Calle 1', minLength: 5 },
                street2: { type: 'string', title: 'Calle 2', minLength: 5 },
                observation: { type: 'string', title: 'Observaciones', minLength: 5 },
                number: { type: 'number', title: 'Numero de casa', minimum: 1 },
            }
        },
        user: {
            type: 'object',
            required: ['name', 'phone', 'document'],
            properties: {
                name: { type: 'string', title: 'Nombre', minLength: 5 },
                document: { type: 'string', title: 'Documento', minLength: 5 },
                phone: { type: 'string', title: 'Teléfono', minLength: 5 },
                email: { type: 'string', title: 'Correo' },
            }
        }
    },
    title: '',
    type: 'object',
    required: ['raceType', 'user'],
    properties: {
        raceType: {
            type: 'string', title: 'Tipo de orden',
            anyOf: [
                { type: "string", enum: ['REMISION'], title: "Remisiones/Reparto" },
                { type: "string", enum: ['SEND_PACKET'], title: "Envio de paquetes" },
                { type: "string", enum: ['TAXI'], title: "Taxi de personas" },
                { type: "string", enum: ['DELIVERY'], title: "Delivery" },
                { type: "string", enum: ['OTHER'], title: "Otro" }
            ],
            default: 'DELIVERY'
        },
        driver: {
            type: 'number', title: 'Conductor',
            anyOf: [{ type: "number", enum: [0], title: "Cargando" }],
            default: 0
        },
        observation: { type: 'string', title: 'Observacion' },
        dueDate: { type: 'string', title: 'Fecha de vencimiento', format: "date-time" },
        withMoney: {
            type: 'boolean',
            title: 'Costo de envío',
            description: 'Especifique si el envío tiene costo:'

        },

        user: { title: 'Cliente', "$ref": "#/definitions/user" },
        origin: { title: "Origen", "$ref": "#/definitions/address" },
        destiny: { title: "Destino", "$ref": "#/definitions/address" },
    },
    dependencies: {
        withMoney: {
            oneOf: [{
                properties: {
                    withMoney: { enum: [false] }
                }
            }, {
                properties: {
                    withMoney: { enum: [true] },
                    amount: { type: "number", title: 'Monto', minimum: 0 }
                },
                required: ['amount']
            }]
        }
    }
};


const uiAddSchema = {
    observation: { "ui:widget": "textarea" },

    name: { "ui:autofocus": true },

    'ui:layout': [
        { raceType: { md: 3 }, driver: { md: 3 }, observation: { md: 3 }, dueDate: { md: 3 } },
        { user: { md: 12 } },
        { origin: { md: 12 } },
        { destiny: { md: 12 } },
        { withMoney: { md: 2 }, amount: { md: 2 } },
    ] as RowDefinition[],

    origin: {
        'ui:layout': [{ street1: { md: 4 }, street2: { md: 3 }, number: { md: 1 }, observation: { md: 4 } }],
        observation: { "ui:widget": "textarea" }
    },
    destiny: {
        'ui:layout': [{ street1: { md: 4 }, street2: { md: 3 }, number: { md: 1 }, observation: { md: 4 } }],
        observation: { "ui:widget": "textarea" }
    },
    user: { 'ui:layout': [{ name: { md: 3 }, document: { md: 3 }, email: { md: 3 }, phone: { md: 3 } }] }
};

class RaceAdd extends React.Component<RaceAddProps, RaceAddState> {


    static getDefaultData(): RaceData {
        return {

            raceType: 'DELIVERY',
            observation: '',
            withMoney: false,
            dueDate: addDays(setMilliseconds(new Date(), 0), 1).toISOString(),
            user: {
                name: '',
                document: ''
            },
            driver: 0,
            origin: { street1: '' },
            destiny: { street1: '' }
        }
    }

    private schemaNextButton: any;

    constructor(props: RaceAddProps) {
        super(props);

        const steps = ['Asignar Ruta', 'Agregar detalles', 'Ver resumen'];
        const state: RaceAddState = {
            steps,
            data: RaceAdd.getDefaultData(),
            activeStep: 0,
            schema: null,
        };
        if (props.config.races.predefinedFrom) {
            state.routeData = {
                origin: props.config.maps.startingLocation
            }
        }

        this.state = state;

        this.handleNext = this.handleNext.bind(this);
        this.successFullSecondStep = this.successFullSecondStep.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.assignOkFormButton = this.assignOkFormButton.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleRouteSelection = this.handleRouteSelection.bind(this);
        this.retry = this.retry.bind(this);
        this.shareInfo = this.shareInfo.bind(this);


        Promise.all([
            getApi().driver().listActiveByAdmin(),
            getApi().client().list(),
        ]).then(([drivers, clients]) => {
            const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(addRaceSchema));
            const driver = newSchema.properties!.driver as JSONSchema6;

            driver.anyOf = drivers.map((d:any) => {
                return {
                    type: "number",
                    enum: [d.id],
                    title: (d.branch && d.branch.name ? d.branch.name : 'Sin sucursal') + ' / ' + (d.user && d.user.name ? d.user.name : '' || d.user.email || '')
                } as JSONSchema6;
            });
            if(driver.anyOf){
                driver.anyOf.splice(0, 0, { type: "number", enum: [0], title: "Sin conductor" });
            }

            this.setState({
                schema: newSchema,
                routeData: {
                    ...this.state.routeData,
                    clients: clients,
                }
            });
        }).catch(error => {
            console.error("Error fetching data:", error);
        });
    }


    shareInfo() {

        if (!this.state.routeData || !this.state.routeData.destiny) {
            return;
        }
        const target = this.state.routeData.destiny;
        const map = `https://maps.google.com/?q=${target.lat},${target.lng}`;
        const link = createWhattsappLink(`Taxio - '${this.state.data.observation}'\nCliente: '${this.state.data.user.name}'\n\n${map}`);
        window.open(link, "_blank");
    }


    assignOkFormButton(formElement: any) {
        this.schemaNextButton = formElement;
    }

    handleNext() {
        const { activeStep } = this.state;
        if (activeStep === 1) {
            this.schemaNextButton.click();

            return;
        }

        if (activeStep === 0) {
            if (!this.state.routeData || !this.state.routeData.fullData) {
                // the route is wrong
                return;
            } else {

                let clientName = '';
                let clientDocument = '';
                let clientPhone;
                let locationId;
                let clientEmail = '';

                if (this.state.routeData && this.state.routeData.clientDocument) {
                    const locationClient = this.state.routeData.clientLocations && this.state.routeData.clientLocations[0];
                    if (locationClient) {
                        clientName = locationClient.client.user.name;
                        clientDocument = this.state.routeData.clientDocument;
                        clientPhone = locationClient.client.phone;
                        clientEmail = locationClient.client.user.email;
                    }

                    if (this.state.routeData.selectedClientLocationId) {
                        locationId = this.state.routeData.selectedClientLocationId;
                    }

                }

                this.setState({
                    data: {
                        ...this.state.data,
                        origin: {
                            ...this.state.data.origin,
                            street1: this.state.routeData.originStreet || '',
                            branch: this.state.routeData.selectedBranch
                        },
                        destiny: {
                            ...this.state.data.destiny,
                            street1: this.state.routeData.destinyStreet || '',
                            id: locationId
                        },
                        user: {
                            ...this.state.data.user,
                            name: clientName,
                            phone: clientPhone,
                            document: clientDocument,
                            email: clientEmail
                        }
                    }
                })



            }
        }

        if (activeStep === 2 && this.state.routeData && this.state.routeData.origin && this.state.routeData.destiny) {
            this.props.handleAdd({
                type: this.state.data.raceType,
                observation: this.state.data.observation,
                clientId: 0,
                clientDocument: this.state.data.user.document,
                clientName: this.state.data.user.name,
                clientEmail: this.state.data.user.email,
                clientPhone: this.state.data.user.phone,
                origin: {
                    ...this.state.data.origin,
                    lat: this.state.routeData.origin.lat,
                    lng: this.state.routeData.origin.lng
                },
                destiny: {
                    ...this.state.data.destiny,
                    lat: this.state.routeData.destiny.lat,
                    lng: this.state.routeData.destiny.lng
                },
                dueDate: +new Date(this.state.data.dueDate || 0),
                amount: this.state.data.amount,
                driver: this.state.data.driver,
                branch: this.state.routeData.selectedBranch ? this.state.routeData.selectedBranch.id : undefined
            });
        }

        this.setState({
            activeStep: activeStep + 1
        });
    };
    handleData = (data: any) => {
        this.props.handleAdd(data);
    };

    successFullSecondStep(form: any) {
        this.setState({
            activeStep: this.state.activeStep + 1,
            data: form.formData
        });

    }

    handleBack() {
        const { activeStep } = this.state;
        this.setState({
            activeStep: activeStep - 1,
        });
    };

    retry() {
        this.setState({
            activeStep: 0
        });
    }

    handleNew() {
        this.setState({
            activeStep: 0,
            data: RaceAdd.getDefaultData(),
            routeData: undefined
        });
    }

    handleRouteSelection(data: RouteData) {
        this.setState({
            routeData: data
        })
    }

    renderStep(step: number) {
        switch (step) {
            case 0:
                return (
                    <>
                        <RouteSelector
                            data={this.state.routeData}
                            config={this.props.config}
                            onNewData={this.handleRouteSelection}
                            sendData={this.handleData}
                            notification={this.props.notification}
                        />
                    </>
                );
            case 1:
                if (!this.state.schema) {
                    return (
                        <CircularProgress size={50} />
                    );
                } else {
                    return (
                        // <></>
                        <EnhancedSchemaForm
                            schema={this.state.schema}
                            uiSchema={uiAddSchema}
                            formData={this.state.data}
                            onSubmit={this.successFullSecondStep}
                        >
                            <div>
                                <Button
                                    style={{ display: 'none' }}
                                    variant='contained'
                                    color='primary'
                                    type='submit'
                                    buttonRef={this.assignOkFormButton}>
                                    Aceptar
                                </Button>
                            </div>
                        </EnhancedSchemaForm>
                    );

                }
            case 2:
                const data = this.state.data;
                const route = this.state.routeData;
                if (!data || !route) {
                    return (<div />);
                }
                let imageUrl: string | null = null;
                if (route.route) {
                    imageUrl = googleMaps.buildStaticImage(this.props.config.maps.key, route.route.overview_polyline);
                }
                console.log(route.route);
                return (<Card>
                    {imageUrl && <CardMedia
                        className={this.props.classes.cardMedia}
                        image={imageUrl}
                        title="Imagen de la ruta"
                    />}
                    <CardContent>
                        <Typography gutterBottom variant="headline" component="h2">
                            {data.raceType}
                        </Typography>
                        <Typography component="p">
                            {data.observation}
                        </Typography>
                        <br />
                        <Typography variant="title">
                            Cliente
                        </Typography>
                        <Typography component="p">
                            Nombre <b>{data.user.name}</b> con
                            documento <b>{data.user.document}</b>
                        </Typography>
                        <br />
                        {data.withMoney &&
                            (
                                <div>
                                    <Typography variant="title">
                                        Cliente
                                    </Typography>
                                    <Typography variant="title">Se necesita <MoneyLabel amount={data.amount} /></Typography>
                                </div>)
                        }
                        <br />
                        <Typography variant="title">
                            Ruta
                        </Typography>
                        <Typography>
                            El viaje es de: <NumberFormat value={(route.distance || 0) / 1000}
                                suffix={'Km.'}
                                displayType={'text'}
                                decimalScale={4} /> , y
                            costará aproximadamente <MoneyLabel amount={route.price} />.
                        </Typography>
                    </CardContent>

                </Card>);
        }

        if (this.props.state === 'added') {
            return (
                <div className={this.props.classes.success}>
                    <br />
                    <CheckCircle color="primary" style={{ fontSize: 80 }} />
                    <br />
                    <br />
                    <Typography variant="title">
                        Carrera creada correctamente
                    </Typography>
                    <br />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNew}>
                        Crear otra
                    </Button>
                    <br />

                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={this.shareInfo}>
                        Enviar datos al chofer
                    </Button>

                </div>);
        }

        if (this.props.state === 'error' && this.props.error) {
            const err = extractError(this.props.error);
            return (
                <div className={this.props.classes.success}>
                    <br />
                    <RemoveCircle color="error" style={{ fontSize: 80 }} />
                    <br />
                    <br />
                    <Typography variant="title">
                        Error {err.type}

                        {err.properties.map(prop => {
                            return (<div key={prop.property}>{prop.property}: {prop.message}</div>)
                        })}
                    </Typography>
                    <br />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.retry}>
                        Reintentar
                    </Button>
                </div>);
        }

        return (
            <div className={this.props.classes.success}>
                <br />
                <CircularProgress color="primary" thickness={7} />
                <br />
                <br />
                <Typography variant="title">Procesando</Typography>
                <br />
            </div>);

    }

    render() {
        const { classes } = this.props;
        const { activeStep } = this.state;

        return (
            <div className={classes.root}>
                {/* <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label, index) => {
                        return (
                            <Step key={label} completed={index < activeStep}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper> */}
                {this.renderStep(activeStep)}
                {/* <div className={classes.buttons}>
                    {activeStep === steps.length ? (
                        <div>
                        </div>
                    ) : (
                        <div>
                            <div>
                                <Button
                                    disabled={activeStep === 0}
                                    onClick={this.handleBack}
                                    className={classes.button}
                                > Atras </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleNext}
                                    className={classes.button}
                                > {activeStep === steps.length - 1 ? 'Crear' : 'Siguiente'} </Button>
                            </div>
                        </div>
                    )}
                </div> */}
            </div>
        );
    }
}


export default withStyles(styles as any)(RaceAdd);



// WEBPACK FOOTER //
// ./src/components/race/raceAdd.tsx